import { useMemo } from "react";
import { getLanguageFormatted } from "../../../utils/string";
import {
  buildGlobalReportPortfolioSnapshot,
  getNonDraftCampaignIDs,
} from "../utils/buildGlobalReportPortfolioSnapshot";
import i18next from "i18next";

export const useGlobalReportAgentContext = ({
  campaigns,
  dateRange,
  totals,
  totalsLastPeriod,
  measurableKpi = null,
}) => {
  const portfolioSnapshot = useMemo(
    () =>
      buildGlobalReportPortfolioSnapshot({
        campaigns,
        dateRange,
        totals,
        totalsLastPeriod,
      }),
    [campaigns, dateRange, totals, totalsLastPeriod]
  );

  const globalReportContext = useMemo(() => {
    if (!dateRange?.startDateTime || !dateRange?.endDateTime) {
      return null;
    }

    return {
      campaignIDs: getNonDraftCampaignIDs(campaigns),
      startDateTime: dateRange.startDateTime,
      endDateTime: dateRange.endDateTime,
      language: getLanguageFormatted(i18next.language),
      portfolioSnapshot,
      measurableKpi: measurableKpi || null,
    };
  }, [campaigns, dateRange, measurableKpi, portfolioSnapshot]);

  return { globalReportContext, portfolioSnapshot };
};

export default useGlobalReportAgentContext;
